import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from '../../_shared/shared.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { PostManagementComponent } from './post-management.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import {DepartmentTree2Module} from '../../_custom/department-tree-2/department-tree-2.module';
const routes: Routes = [
  {
    path: '',
    component: PostManagementComponent,
    data: {
      title: 'Báo Cáo Bài Viết Và Bình Luận'
    },
  }

];
@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    TabsModule,
    DataTablesModule,
    HttpClientModule,
    ModalModule.forRoot(),
    Daterangepicker,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    NgxPaginationModule,
    DepartmentTree2Module
  ],
  declarations: [PostManagementComponent]
})
export class PostManagementModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/post-management/post-management.module.ts